import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ManualTaxInvoiceDetailPage = lazy(
  () => import("@/pages/tools.manual-tax-invoices.$id.page"),
);

export const Route = createFileRoute("/tools/manual-tax-invoices/$id")({
  component: ManualTaxInvoiceDetailPage,
});
